import { iconNames as names, staticIcons } from './generated/icons';
import type { IconProps } from './icon';

export const IconStatic = ({ name, color, width, height, size = 20, stroke, className, ...props }: IconProps) => {
    let icon = name;

    if (names.indexOf(name) === -1) {
        icon = 'IcClose';
    }

    const IconComponent = staticIcons[icon];

    return (
        <IconComponent
            data-name={`icon-${icon}`.toLowerCase()}
            width={width || size}
            height={height || size}
            color={color}
            className={className}
            {...(stroke ? { strokeWidth: `${stroke}px` } : {})}
            // accessibility
            aria-hidden={true}
            focusable={false} // See: https://allyjs.io/tutorials/focusing-in-svg.html#making-svg-elements-focusable
            {...props}
        />
    );
};
